import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import { OverlayTrigger } from 'react-bootstrap';
import { useAgencyCreators } from '../../../shared/hooks/useAgencyCreators';
import { User } from '../../../model/user/User';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { setSelectetInfluencer } from '../../../store/agency/agencySlice';
import { CustomImageHandler } from '../../../shared/components/CustomImageHandler';

export function AgencyCreatorHeaderList() {
    const { selectedInfluencer } = useSelector((state: IAllStates) => state.agency);
    const { users } = useAgencyCreators();
    const dispatch = useDispatch();
    const selectInfluencer = (user: Partial<User>) => {
        if (selectedInfluencer?.id !== user.id) {
            dispatch(setSelectetInfluencer(user));
        }
    };
    const isSelectedOutOfList =
        !!selectedInfluencer?.id && users?.slice(0, 6).every(user => user.id !== selectedInfluencer?.id);
    return (
        <>
            {users?.slice(0, 6).map(item => {
                return (
                    <div onClick={() => selectInfluencer(item)} key={item.id} className="mr-2 cursor-pointer">
                        <OverlayTrigger
                            key={`${item.id + item?.firstName}`}
                            overlay={
                                <Tooltip placement="bottom" id={`tooltip-bottom`}>
                                    {!!item.displayName ? item.displayName : item.firstName + ' ' + item.lastName}
                                </Tooltip>
                            }
                        >
                            <div
                                className={
                                    item?.id === selectedInfluencer?.id
                                        ? 'position-relative user-border rounded-circle'
                                        : 'position-relative'
                                }
                            >
                                <CustomImageHandler
                                    photoPath={item?.profilePhoto?.thumbnail}
                                    classes="agency-filter-rounded-img img-cover"
                                    altTag="User Profile"
                                    placeholder="/icons/UserPlaceholder.png"
                                    name={!!item.displayName ? item.displayName : item.firstName + ' ' + item.lastName}
                                />
                                {item?.id === selectedInfluencer?.id && <p className="active-user mb-0">Active</p>}
                            </div>
                        </OverlayTrigger>
                    </div>
                );
            })}
            {isSelectedOutOfList && (
                <div onClick={() => selectInfluencer(selectedInfluencer)} className="mr-2 cursor-pointer">
                    <OverlayTrigger
                        overlay={
                            <Tooltip placement="bottom" id={`tooltip-bottom`}>
                                {!!selectedInfluencer.displayName
                                    ? selectedInfluencer.displayName
                                    : selectedInfluencer.firstName + ' ' + selectedInfluencer.lastName}
                            </Tooltip>
                        }
                    >
                        <div className={'position-relative user-border rounded-circle'}>
                            <CustomImageHandler
                                photoPath={selectedInfluencer?.profilePhoto?.thumbnail}
                                thumbnailPath={selectedInfluencer?.profilePhoto?.thumbnail}
                                classes="agency-filter-rounded-img img-cover"
                                altTag="User Profile"
                                name={
                                    !!selectedInfluencer.displayName
                                        ? selectedInfluencer.displayName
                                        : selectedInfluencer.firstName + ' ' + selectedInfluencer.lastName
                                }
                            />
                            <p className="active-user mb-0">Active</p>
                        </div>
                    </OverlayTrigger>
                </div>
            )}
        </>
    );
}
